export function generateBlob(canvas, mimeType) {
    return new Promise((resolve, reject) => {
        try {
            canvas.toBlob(resolve, mimeType);
        }
        catch (e) {
            reject(e);
        }
    });
}
// Draw a 2d image
export function drawImage(canvas, image, width, height, cropX, cropY, dWidth, dHeight) {
    width = Math.floor(width);
    height = Math.floor(height);
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d", { alpha: false });
    if (cropX !== undefined) {
        ctx.drawImage(image, Math.floor(cropX), Math.floor(cropY), image.width, image.height, 0, 0, Math.floor(dWidth), Math.floor(dHeight));
    }
    else {
        ctx.drawImage(image, 0, 0, width, height);
    }
}
//# sourceMappingURL=canvas.js.map